<meta-content-detail [type]="'guide'" [cover]="guide.image" [title]="guide.title" [description]="guide.description"
    (openContent)="openGuide.emit()" />